import React, { useState } from "react";
import { addComponent } from '../utils/add-component';
import ShowDebugInfo from "../utils/show-debuginfo"
import Moment from 'moment';
import { useSnStore } from "../store/sn-store";
  
export function NestedLeisureMangaTranslationItem(props) {
  console.log('%cNestedLeisureMangaTranslationItem', "font-size:16px;color:green", { props: props });
  // const repo = useRepository(); // not used
  const [itemCollection] = useState([]); // setCollection not used
  let context = props.data;
  const {page, layout} = useSnStore((state) => state);
  const widget = props.widget;
  console.log('nestedLeisureMangaTranslationItem', props, context);
  
  return (
    // <div className="w3-col m9 w3-right">
    <div className="w3-row-padding w3-margin-bottom w3-left w3-block">
      <div className="w3-col">
        <div className="w3-card w3-round w3-white">
        <ShowDebugInfo title="leisure manga translation news item" context={context} currentPage={page} widget={widget} />
          <div className="w3-container w3-padding">
            <div className="w3-clear news-container">
                {itemCollection.slice(0,1).map((child) => 
                            addComponent('widgets', 'nested','review-list-image', `${context.Id}-${child.Id}`, child, layout, child)
                          )}
                {/* <Link key={`news-item-${context.Id}`} to={'/' + relativePath} className="no-score"> */}
                <div className="w3-left">
                  <a key={`news-item-${context.Id}`} href={context.Url} target="_blank" rel="noreferrer" className="no-score">
                    <div className="w3-left w3-padding news-meta">
                      <div className="w3-large">
                        <i className="fa fa-download fa-fw related-link-icon"></i>
                        {context.DisplayName}
                      </div>
                    </div>
                    </a>
                </div>
                
                {/* </Link> */}
              </div>                
              <div className="w3-left">
                <a key={`news-item-${context.Id}`} href={context.Url} target="_blank" rel="noreferrer" className="no-score">
                    <div className="w3-left w3-padding news-meta">
                      <div className="small" dangerouslySetInnerHTML={{ __html: context.Lead }}></div>
                      <div dangerouslySetInnerHTML={{ __html: context.Description }}/>
                      <div className="small hidden">{context.Author}</div>
                      <div>{Moment(context.PublishDate).format('yyyy.MM.DD')}</div>
                    </div>
                  </a>
                </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default NestedLeisureMangaTranslationItem
